// Class admin logic
((Drupal) => {
  "use strict";

  Drupal.behaviors.schoolsPages = {
    attach(context) {
      const handleButtonClick = (buttonSelector, actions) => {
        const button = context.querySelector(buttonSelector);
        if (button && !button.dataset.onceSchoolsPages) {
          button.dataset.onceSchoolsPages = true;
          button.addEventListener("click", (event) => {
            event.preventDefault();
            actions();
          });
        }
      };

      const redirectToBaseUrl = () => {
        const currentUrl = window.location.href;
        const redirectUrl = currentUrl.replace(/\/edit$/, "");
        window.location.href = redirectUrl;
      };

      // Action: Show the class creation form
      handleButtonClick("#teacherAddClass", () => {
        document.querySelector("#schoolClassList")?.classList.remove("show");
        document.querySelector("#schoolClassForm")?.classList.add("show");
        window.scrollTo({ top: 0, behavior: "smooth" });
      });

      // Action: Cancel class creation
      handleButtonClick("#teacherCancelAddClass", () => {
        document.querySelector("#schoolClassList")?.classList.add("show");
        document.querySelector("#schoolClassForm")?.classList.remove("show");
        window.scrollTo({ top: 0, behavior: "smooth" });
      });

      // Action: Redirect for canceling student addition or class editing
      handleButtonClick("#teacherCancelAddStudents", redirectToBaseUrl);
      handleButtonClick("#teacherCancelEditClass", redirectToBaseUrl);
    },
  };
})(Drupal);
